import * as React from 'react';
import { CorePopover, } from '../internal/WixUiCoreComponents/components/CorePopover';
import { generateKey } from '../../common/random';
import { st, classes } from './Popover.st.css';
import { PopoverTriggerAction } from './types';
const ReffedPopover = (props, ref) => {
    const { triggerAction, wiredToSiteColors, children, className, shown, ...rest } = props;
    const [isShown, setIsShown] = React.useState(false);
    const isControlled = React.useRef(typeof shown !== 'undefined' ||
        triggerAction === PopoverTriggerAction.click);
    const id = React.useRef(generateKey('popover'));
    const isVertical = React.useMemo(() => ['bottom', 'top'].some((position) => new RegExp(position).test(props.placement)), [props.placement]);
    const [Element, Content] = React.Children.toArray(children).sort((e1, e2) => {
        if (![e1, e2].every(React.isValidElement)) {
            return undefined;
        }
        return e1.type === Popover.Element ? -1 : 0;
    });
    return (React.createElement(CorePopover, { ref: ref, showArrow: true, shown: shown ?? isShown, moveBy: isVertical ? { y: 8 } : { x: 8 }, className: st(classes.root, { wired: wiredToSiteColors }, className), ..._getCoreProps(isControlled), ...rest },
        React.cloneElement(Element, {}, React.cloneElement(Element.props.children, _getTriggerProps(isControlled))),
        Content));
    function _getTriggerProps(_isControlled) {
        switch (triggerAction) {
            case PopoverTriggerAction.hover:
                return {
                    'aria-describedby': id.current,
                    ...(_isControlled.current
                        ? {}
                        : {
                            onFocus: _handleOpen,
                            onBlur: _handleClose,
                        }),
                };
            case PopoverTriggerAction.click:
            default:
                return {};
        }
    }
    function _getCoreProps(_isControlled) {
        switch (triggerAction) {
            case PopoverTriggerAction.click:
                return {
                    role: 'dialog',
                    appendTo: 'parent',
                };
            case PopoverTriggerAction.hover:
            default:
                return {
                    ...(_isControlled.current
                        ? {}
                        : {
                            onMouseEnter: _handleOpen,
                            onMouseLeave: _handleClose,
                        }),
                    role: 'tooltip',
                    id: id.current,
                };
        }
    }
    function _handleOpen() {
        setIsShown(true);
    }
    function _handleClose() {
        setIsShown(false);
    }
};
export const Popover = Object.assign(React.forwardRef(ReffedPopover), {
    Element: CorePopover.Element,
    Content: CorePopover.Content,
});
Popover.defaultProps = {
    triggerAction: PopoverTriggerAction.hover,
    wiredToSiteColors: true,
    placement: 'top',
};
Popover.displayName = 'Popover';
//# sourceMappingURL=Popover.js.map